// OK
// import axios from "axios";
import Properties from "../properties"
import apiClient from "../plugins/axios-instance";

const API_URL = "https://pelanggan." +Properties.DOMAIN_URL +"/api/v1";

export default class NotifikasiAPIService {
  constructor() {}
  static getAllNotifikasi = (limit, page) =>
    apiClient.get(API_URL + "/notifikasis/limit/" + limit + "?page=" + page, {
    });
  static getNotifikasi = (limit, page, kode) =>
    apiClient.get(
      API_URL +
        "/notifikasis/kode_promo/" +
        kode +
        "/limit/" +
        limit +
        "?page=" +
        page,
      {
      }
    );
  static editNotifikasi = (kode, notif) =>
    apiClient.post(API_URL + "/notifikasis/" + kode, notif, {
      "Content-Type": "multipart/form-data",
    });
  static sendNotifikasi = (kode, nik) =>
    apiClient.post(
      API_URL + "/notifikasis/send-notification/" + kode,
      {
        user_update: nik,
      },
      {
      }
    );

  static createNotifikasi = (notif) =>
    apiClient.post(API_URL + "/notifikasis", notif, {
      "Content-Type": "multipart/form-data",
    });
  static deleteNotifikasi = (kode, nik) =>
    apiClient.delete(
      API_URL + "/notifikasis/" + kode,
      {
        params: {
          user_update: nik,
        },
      }
    );

  static getConst = (kode) =>
  apiClient.get(
    API_URL + "/cosnt-notifs/kategori/" + kode,
    {
    }
  );

  static editConstNotif = (kode, notif) =>
    apiClient.post(API_URL + "/cosnt-notifs/" + kode, notif, {
      "Content-Type": "multipart/form-data",
    });
}
